import React, { memo, useCallback, useReducer } from 'react';
import styles from './index.module.scss';
import Select from "../../Select";
import Button from "../../Button";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

const generateSchema = (keys: string[]) => {
  return yup.object(Object.fromEntries(keys.map(key => ([key, yup.string().required('Required'),])))).required()
};

type SelectData = {
  [key: string]: SelectData | string
}

interface Props {
  placeholderText: string[],
  data: SelectData
}

const DropdownNavigation = ({placeholderText, data}:Props) => {
  const navigate = useNavigate();
  const [structuredData, updateStructuredData] = useReducer((state: any, fields: { [key: string]: OptionObject[] }) => {
    return {...state, ...fields}
  }, data, (initialData: any) => ({[placeholderText[0]]: Object.keys(initialData).map(key => ({label: key, value: key}))}));
  const { setValue, handleSubmit, watch, formState: { errors }, trigger } = useForm({
    resolver: yupResolver(generateSchema(placeholderText)),
    mode: 'onChange'
  });
  const onSubmit = useCallback((values: any) => {
    navigate(values[placeholderText[placeholderText.length - 1]])
  }, [navigate, placeholderText]);
  const fields = watch();
  const updateField = useCallback((field: string, {label, value}: OptionObject) => {
    setValue(field, value)
    trigger(field)

    let inheritance = 0;
    const findOptions = (obj: any, key: string): any => {
      if(obj[key]) return obj[key]
      else {
        const parentKey = placeholderText[inheritance]
        inheritance += 1
        return findOptions(obj[fields[parentKey] || label], key)
      }
    }

    const nextInputOptions = findOptions(data, label);
    const structuredOptions = Object.entries(nextInputOptions).map(([label, value]) => ({label, value}))
    const dependentFields = placeholderText.slice(inheritance+1);


    updateStructuredData(Object.fromEntries(dependentFields.map((key, i) => {
      return i === 0 ? [key, structuredOptions as OptionObject[]] : [key, []]
    })))

    //Reset all dependent fields
    dependentFields.forEach(key => setValue(key, ''))
  }, [setValue, trigger, placeholderText, fields, data]);

  return (
    <form onSubmit={handleSubmit(onSubmit)} className={styles.buttonsWrapper}>
      <div className={styles.flex}>
        {placeholderText.map((fieldName, i) => {
          return (
            <Select
              placeholder={fieldName}
              options={structuredData[fieldName] || []}
              theme={'dark'}
              value={fields[fieldName] || ''}
              onChange={updateField.bind(null, fieldName)}
              error={errors[fieldName]?.message}
              noOptionsMessage={'Fetching data...'}
              key={i}
            />
          )
        })}
      </div>
      <Button className={styles.button} text={'Continue'} type={'submit'} />
    </form>
  )
}

export default memo(DropdownNavigation)
